<template>
    <div class="video-wrap" :class="{loading: loading, mobile: isMobile, self: self}"  ref="container">
        <video ref="screen" :muted="muted" :class="{self: self && !unflip, fullscreen}"></video>
        <div class="loader-wrap" v-if="loading && !self">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        <div class="loader-wrap" v-if="(self && stream === null) || error">
            <span class="material-icons icon">
                warning
            </span>
        </div>
        <!-- <div class="fullscreen-icon" v-if="!self" @click.stop="handleFullscreen">
            <span class="material-icons">
                fullscreen
            </span>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        stream: {
            type: MediaStream,
            default: null
        },
        muted: {
            type: Boolean,
            default: false
        },
        self: {
            type: Boolean,
            default: false
        },
        shareScreen: {
            type: Boolean,
            default: false
        },
        unflip: Boolean,
        isMobile: Boolean
    },
    watch: {
        stream (val) {
            if (val !== null) {
                this.loading = false
                this.start()
            }
        }
    },
    data () {
        return {
            loading: true,
            error: false,
            fullscreen: false,
            height: null
        }
    },
    computed: {
        style () {
            return {
                height: this.height
            }
        }
    },
    mounted () {
        this.checkVideo()
        
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleVideoSize)
    },
    methods: {
        start () {
            this.$refs.screen.srcObject = this.stream
            this.$refs.screen.play()
        },
        checkVideo () {
            let time = Date.now()
            setTimeout(() => {
                if (this.stream !== null) {
                    this.loading = false
                    this.stream.onended = () => {
                        this.loading = true
                        this.checkVideo()
                    }
                    this.start()
                    return
                }
                if (Date.now() - time > 5000 && !this.error) {
                    this.error = true
                }
                this.checkVideo()
            }, 5);
        },
        handleMute () {
            this.$emit('mute', !this.muted)
        },
        handleShare () {
            this.$emit('start-sharing', !this.shareScreen)
        },
        // handleFullscreen () {
        //     this.fullscreen = !this.fullscreen
        //     if (this.fullscreen) {
        //         this.$refs.screen.requestFullscreen()
        //     } else {
        //         document.exitFullscreen();
        //     }
        // }
    }
}
</script>

<style lang="scss" scoped>
.video-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    &.loading {
        background: #000;
    }
}
.mute {
    position: absolute;
    top: 10px;
    right: 20px;
    background: #ffffff77;
    text-decoration: none;
}
video {
    &.self {
        transform: scale(-1, 1);
    }
}
        video::-webkit-media-controls {
            display:none !important;
        }
.fullscreen-icon {
    position: absolute;
    top: 3%;
    left: 3%;
    cursor: pointer;
    .material-icons {
        color: #fff
    }
}

.icon {
    font-size: 5rem;
    color: #fff;
}
.mobile {
    &.self {
        position: absolute;
        bottom: 5%;
        right: 5%;
        width: 30%;
        height: auto;
    }
    height: 100%;
    width: 100%;
}

// loader
.loader-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


</style>